var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockFolderTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1024",
    "data-name": "Grupo 1024",
    transform: "translate(-375 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder_open_black_24dp",
    transform: "translate(375 246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14116",
    "data-name": "Trazado 14116",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14117",
    "data-name": "Trazado 14117",
    d: "M20,6H12L10,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V8A2.006,2.006,0,0,0,20,6Zm0,12H4V8H20Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock_black_24dp",
    transform: "translate(382.91 254.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14138",
    "data-name": "Trazado 14138",
    d: "M0,0H8.18V8.18H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14139",
    "data-name": "Trazado 14139",
    d: "M8.771,3.386H8.431V2.7a1.7,1.7,0,1,0-3.408,0v.682H4.682A.684.684,0,0,0,4,4.067V7.476a.684.684,0,0,0,.682.682h4.09a.684.684,0,0,0,.682-.682V4.067A.684.684,0,0,0,8.771,3.386ZM6.727,6.453a.682.682,0,1,1,.682-.682A.684.684,0,0,1,6.727,6.453ZM7.783,3.386H5.67V2.7a1.057,1.057,0,0,1,2.113,0Z",
    transform: "translate(-2.637 -0.659)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFolderTree);
export default __webpack_public_path__ + "static/media/lockFolderTree.651385e60f0cf6e9d61c3c47660a00ad.svg";
export { ForwardRef as ReactComponent };